/**
 * @param  {Object} state
 * @return {Object}
 */
export const works = state => {
  return state.data
}



// WEBPACK FOOTER //
// ./src/store/modules/works/getters.js